import React from 'react'
import { Fragment } from 'react'
import DeviceIdLink from './DeviceIdLink'
import { spaceCamel } from '../common/commonUtilities'
import {
  IDENTIFIERS,
  UNKNOWN_DEVICE_TYPE,
  MPAN,
  MPRN
} from '../common/constants'
import Table from 'react-bootstrap/Table'
import { isIdentifier } from '../common/commonUtilities'
import CopyButtonForText from '../common/components/CopyButtonForText'
import { duisTerms } from '../common/commonUtilities'

// display an object's keys and values as a table
export default function ObjectToTableContents({
  targetObject,
  setDeviceLoaded,
  setDeviceId,
  isNested = false
}) {

  if (targetObject?.['deviceID'] === '00-00-00-00-00-00-00-00') {
    return null
  }
  // key is a going to be a string eg 'MPAN',
  // target object a hash (map?/dictionary?) eg {MPAN: '2000000067135', post_code: 'W7 2EN', address: '28,,ROSEBANK ROAD,,HANWELL,LON', MPxNDeviceDetails: {…}}
  const identifierKey = (key) => {
    return IDENTIFIERS.includes(key)
  }

  const deviceTypeForLink = (targetObject) => {
    if (targetObject['deviceType']) {
      return targetObject['deviceType']
    }
    if (targetObject[MPAN]) {
      return MPAN
    }
    if (targetObject[MPRN]) {
      return MPRN
    }
  }

  return (
    <Fragment>
      {(isNested && !Array.isArray(targetObject)
        ? Object.keys(targetObject).sort((a, b) => a.localeCompare(b))
        : Object.keys(targetObject)
      ).map((key) => {
        return (
          <tr key={key}>
            <td>
              {isIdentifier(key) ? (
                <CopyButtonForText textToCopy={key}>
                  <DeviceIdLink
                    setDeviceId={setDeviceId}
                    setDeviceLoaded={setDeviceLoaded}
                    deviceId={key}
                    deviceType={targetObject[key]}
                  />
                </CopyButtonForText>
              ) : (
                spaceCamel(key)
              )}
            </td>
            <td
              className={
                !(
                  typeof targetObject[key] === 'object' &&
                  targetObject[key] !== null
                )
                  ? 'copy-button-container'
                  : ''
              }
            >
              {typeof targetObject[key] === 'object' &&
              targetObject[key] !== null ? (
                <Table striped bordered hover size="sm" className="d-flex m-0">
                  <tbody>
                    <ObjectToTableContents
                      targetObject={targetObject[key]}
                      setDeviceLoaded={setDeviceLoaded}
                      setDeviceId={setDeviceId}
                      isNested={true}
                    />
                  </tbody>
                </Table>
              ) : (
                <Fragment>
                  {identifierKey(key) && !targetObject['client_id'] ? (
                    <CopyButtonForText textToCopy={targetObject[key]}>
                      <DeviceIdLink
                        setDeviceId={setDeviceId}
                        setDeviceLoaded={setDeviceLoaded}
                        deviceId={targetObject[key]}
                        deviceType={
                          deviceTypeForLink(targetObject) || UNKNOWN_DEVICE_TYPE
                        }
                      />
                    </CopyButtonForText>
                  ) : // exclude short DUIS terms from copy button wrapping e.g. 'GSME' in the linkedDevices list
                    Object.values(duisTerms).map(v => v.trim()).includes(targetObject[key])  ? (
                    <span>{targetObject[key]}</span>
                  ) : (
                    <CopyButtonForText textToCopy={targetObject[key]}>
                      {targetObject[key]}
                    </CopyButtonForText>
                  )}
                </Fragment>
              )}
            </td>
          </tr>
        )
      })}
    </Fragment>
  )
}
